import React from 'react';
import { connect } from 'react-redux';

import i18n from '../core/i18n';
import GoalItem from './ListItem';
import Render from '../common/Render';

class List extends React.Component {
  renderAfterLoading = () => {
    const { goals, isCurrentUser, enableEmptyState, user } = this.props;

    if (!goals.length && enableEmptyState) {
      return (
        <React.Fragment>
          <div className="u-margin-bottom-micro u-text-left">
            {i18n.t('user.noneGoalsAdded')}
          </div>
          <div className="u-margin-bottom-small u-text-left">
            {i18n.t('user.noneGoalsAddedMotivation')}
          </div>
        </React.Fragment>
      );
    }

    return goals.map((goal) => (
      <GoalItem
        user={user}
        isCurrentUser={isCurrentUser}
        key={goal._id}
        goal={goal}
      />
    ));
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

List.defaultProps = {
  enableEmptyState: true,
};

const mapStateToProps = ({ user }, { user: incomingUser }) => ({
  goals: incomingUser && incomingUser.goals,
  isCurrentUser: user.data && user.data._id === incomingUser._id,
  isLoading: user.isLoading,
  error: user.error,
});

export default connect(mapStateToProps)(List);



// WEBPACK FOOTER //
// ./src/goals/List.js